import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/international-luggage-storage-and-shipping.jpg'),
    alt: 'international luggage storage and shipping page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'international luggage storage and shipping page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'International <span>Luggage</span><span>Storage And Shipping Services</span>',
  description:
    'ShipAndStorage offers secure, cost-effective international luggage storage and shipping services for travelers, relocators, and those needing long-term storage.',
  image: {
    url: '/images/v2/pages/landing-pages/international-luggage-storage-and-shipping/hero-image.jpg',
    alt: 'International Luggage Storage And Shipping Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up' }
}

export const ourProcessSectionContent = {
  title: 'Affordable Global Luggage Storage And Shipping',

  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Reserve Today' },

  image: {
    url: '/images/v2/pages/landing-pages/international-luggage-storage-and-shipping/affordable-global-luggage-storage-and-shipping.png',
    alt: 'Affordable Global Luggage Storage And Shipping'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Online Booking',
      description:
        'Our simple online booking process allows you to choose your international luggage storage and shipping plan in just a few clicks. Select your storage duration and shipping destination.',
      image: {
        src: '/images/v2/pages/common/easy-booking-tracking.png',
        alt: 'Easy Online Booking'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Facilities',
      description:
        "We offer climate-controlled, high-security storage facilities worldwide. Your luggage is kept safe until you're ready to have it shipped to your desired location.",
      image: {
        src: '/images/v2/pages/common/secure-packaging-labeling.png',
        alt: 'Secure Storage Facilities'
      }
    },
    {
      id: 3,
      title: 'Fast & Reliable International Shipping',
      description:
        "Once you're ready to receive your belongings, we ensure timely and secure international delivery. We partner with trusted logistics providers for a hassle-free shipping experience.",
      image: {
        src: '/images/v2/pages/common/fast-and-reliable-delivery.png',
        alt: 'Fast & Reliable International Shipping'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Fast International Luggage Shipping Services',
  description:
    "At ShipAndStorage, we prioritize speed, security, and reliability in our international luggage storage and shipping services. Whether you're traveling for business, studying abroad, or relocating, we provide fast shipping options to ensure your luggage arrives at your destination safely and on time. With global coverage and seamless delivery tracking, we make international shipping stress-free.",
  image: {
    src: '/images/v2/pages/landing-pages/international-luggage-storage-and-shipping/fast-international-luggage-shipping-services.jpg',
    alt: 'Fast International Luggage Shipping Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of International Luggage Storage and Shipping',

  cards: [
    {
      id: 1,
      title: 'Hassle-Free Travel',
      description:
        'Travel light and stress-free by storing your luggage securely. Have it shipped to your destination when needed, eliminating the inconvenience of carrying heavy bags.',
      image: {
        src: '/images/v2/pages/common/hassle-free-travel.png',
        alt: 'Hassle-Free Travel'
      }
    },
    {
      id: 2,
      title: 'Cost-Effective & Convenient',
      description:
        'Avoid high airline baggage fees and overweight charges with our international luggage storage and shipping services. Enjoy budget-friendly storage and shipping options tailored to your needs.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Cost-Effective & Convenient'
      }
    },
    {
      id: 3,
      title: 'Secure & Climate-Controlled Storage',
      description:
        'Our storage facilities are designed to keep your belongings safe with 24/7 monitoring and climate control, ensuring the protection of sensitive items.',
      image: {
        src: '/images/v2/pages/common/enhanced-security2.png',
        alt: 'Secure & Climate-Controlled Storage'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for International Luggage Storage and Shipping?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Frequent Business Travelers',
          description: 'Store your luggage and ship it between international business trips for seamless travel.'
        },
        {
          id: 2,
          title: 'Students Studying Abroad',
          description: 'Keep your belongings safe during semester breaks or while transitioning between dorms.'
        },
        {
          id: 3,
          title: 'Expats & Relocators',
          description: 'Moving to a new country? Store and ship your luggage securely with us.'
        },
        {
          id: 4,
          title: 'Vacationers & Tourists',
          description: 'Travel hassle-free while we store and deliver your luggage to your next destination.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/international-luggage-storage-and-shipping/who-should-choose-us-for-international-luggage-storage-and-shipping.jpg',
        alt: 'Who Should Choose Us for International Luggage Storage and Shipping?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Residential Storage',
      description:
        'We provide secure and accessible storage solutions for homeowners in need of extra space during renovations, relocations, or decluttering.',
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Residential Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Moving Storage',
      description:
        'Seamless storage and shipping options for individuals and families moving locally or internationally. We make transitions smoother by storing and delivering your belongings as needed.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage',
      description:
        'Designed for businesses needing storage for inventory, trade show materials, or office essentials. Our solutions help businesses stay organized and efficient.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'College Storage',
      description:
        'Affordable and secure storage for students during summer breaks, semester transitions, or study abroad programs. Store books, furniture, and dorm essentials with ease.',
      image: {
        src: '/images/v2/pages/common/student-storage-options.png',
        alt: 'College Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for International Luggage Storage and Shipping?',

  image: {
    url: '/images/v2/pages/landing-pages/international-luggage-storage-and-shipping/why-choose-us-for-international-luggage-storage-and-shipping.jpg',
    alt: 'Why Choose Us for International Luggage Storage and Shipping?'
  },

  articles: [
    {
      id: 1,
      title: 'Global Reach',
      description:
        'We offer international shipping and storage services, ensuring your luggage reaches you anywhere in the world.'
    },
    {
      id: 2,
      title: 'Fast & Reliable Delivery',
      description: 'Get your luggage delivered quickly and securely through our trusted shipping partners.'
    },
    {
      id: 3,
      title: 'Secure Storage',
      description: 'Our facilities are equipped with 24/7 security and climate control to keep your belongings safe'
    },
    {
      id: 4,
      title: 'Easy Booking Process',
      description: 'Our user-friendly online platform makes booking storage and shipping effortless.'
    },
    {
      id: 5,
      title: 'Affordable Pricing',
      description: 'Save on airline baggage fees and costly moving services with our budget-friendly options.'
    },
    {
      id: 6,
      title: 'Trusted Logistics Partners',
      description: 'We work with leading carriers to ensure smooth and reliable shipping.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'International Luggage Storage And Shipping Services Available',
  description:
    'International luggage storage and shipping services available. Fast, secure, and affordable options for global storage and shipping.',
  image: {
    src: '/images/v2/pages/landing-pages/international-luggage-storage-and-shipping/international-luggage-storage-and-shipping-services-available.png',
    alt: 'International Luggage Storage And Shipping Services Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Store & Ship' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description: 'We partner with leading shipping companies to ensure secure and reliable services for your needs.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx provides dependable shipping solutions for your office equipment, guaranteeing timely and safe delivery.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL specializes in international shipping solutions, catering to your office equipment storage and retrieval needs.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers reliable transportation for your stored office equipment, ensuring a seamless experience.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
